import React from 'react';

import { Buttons } from 'shared';
import { WithLoadingProps } from 'shared/buttons/with-loading';

import { ButtonCssProps, useStyles } from './styles';

type BaseButtonProps = Omit<WithLoadingProps, 'disableElevation'> & ButtonCssProps;

const BaseButton: React.FC<BaseButtonProps> = ({
  borderRadius,
  labelClass,
  children,
  fullWidth,
  textTransform,
  className = '',
  ...props
}) => {
  const classes = useStyles({ borderRadius, textTransform });

  return (
    <Buttons.WithLoading
      {...props}
      classes={{ root: `${classes.root} ${className}` }}
      fullWidth={fullWidth ?? true}
      disableElevation
      labelClass={labelClass ?? classes.defaultLabel}
    >
      {children}
    </Buttons.WithLoading>
  );
};

export default BaseButton;
